import {
  createContext,
  useContext,
} from 'react';
import {
  PatientAuthorizationUtilizationState,
} from 'dtos/patientAuthorizationUtilizationState';
import type {
  ClaimAuthorizationOption,
} from 'views/EMR/components/Authorizations/utils';
import {
  normalizeAuthorizationNumber,
} from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/utils';

export const authorizationUsageEligibleStatuses = new Set([
  'Ready', 'Submitted', 'Acknowledged', 'Rejected', 'Posted', 'Denied', 'Paid', 'Archived',
]);

export const UsedAuthorizationsContext = createContext<{
  authorizationNumbers: readonly string[];
  claimStatus?: string | null;
}>({ authorizationNumbers: [] });

export function useHideUsedAuthorizationStatus(option: ClaimAuthorizationOption): boolean {
  const { authorizationNumbers, claimStatus } = useContext(UsedAuthorizationsContext);
  return authorizationUsageEligibleStatuses.has(claimStatus ?? '')
    && (option.status === PatientAuthorizationUtilizationState.Exhausted
      || option.status === PatientAuthorizationUtilizationState.PartlyExhausted)
    && authorizationNumbers.some((number) => (
      normalizeAuthorizationNumber(number) === normalizeAuthorizationNumber(option.authorizationNumber)
    ));
}
